import DefaultColumn from "components/Table/components/DefaultColumn";
import moment from "moment";
import "moment/locale/id";

moment.locale("id");
const TABLE_COLUMN = [
  {
    accessorKey: "user_sales.sales_name",
    header: "Nama Sales",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
  },
  {
    accessorKey: "gudang.gudang_name",
    header: "Gudang",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
  },
  {
    accessorKey: "status",
    header: "Status Stock",
    cell: (info) => {
      const getClassname = () => {
        if (info.getValue() === 1) {
          return "bg-orange-200 text-orange-600 flex h-8 w-fit items-center justify-center rounded-lg px-4 ";
        } else if (info.getValue() === 2) {
          return "bg-[#BEDBFE] text-[#3A65FF] flex h-8 w-fit items-center justify-center rounded-lg px-4 ";
        }

        return "";
      };

      return (
        <DefaultColumn>
          <div className={getClassname()}>
            {info.getValue() === 1 ? "Stock Loaded" : "Stock Unloaded"}
          </div>
        </DefaultColumn>
      );
    },
  },
  {
    accessorKey: "load_date",
    header: "Load Date",
    cell: (info) => (
      <DefaultColumn>
        {moment(info.getValue()).format("DD MMMM YYYY HH:mm")}
      </DefaultColumn>
    ),
  },
  {
    accessorKey: "unload_date",
    header: "Unload Date",
    cell: (info) => (
      <DefaultColumn>
        {info.getValue()
          ? moment(info.getValue()).format("DD MMMM YYYY HH:mm")
          : "-"}
      </DefaultColumn>
    ),
  },
];

export { TABLE_COLUMN };
